// extracted by mini-css-extract-plugin
export default {"inputRow":"CreateInvoiceInformation_inputRow__DKth+","flex":"CreateInvoiceInformation_flex__zsSVF"};